<template>
	<div class="asideTab">
			<el-scrollbar style="height: 100vh;">
		    <el-aside class='personal-aside'>
				<ul >
					<li :class=" {'active' :isactive === item.active,'btn-item':true}"  v-for="(item,index) in btnList" :key="index" v-if="userPos == item.userPos && vipLevel == item.vipLevel && !item.isShopsooo"   @click="topage(item,index,0)">
						<span><i :class="item.icon"></i>{{item.name}}</span>
						<i v-if="item.haschildren" :class="item.isShow ? 'el-icon-arrow-down': 'el-icon-arrow-up'"></i>
						<span style="margin-left: 10px;" v-show="unreadnum && item.id == 16 " class="cirlce">{{unreadnum}}</span>
						<span style="margin-left: 10px;" class="cirlce" v-if="item.active == '/godownentry'" v-bind:title='descTitle' @mouseenter="descTitle='待仓库确认收货'">{{purchaseNum}}</span>
						<span style="margin-left: 10px;" class="cirlce" v-if="purchaseNum > 0 && item.id == 7" v-bind:title='descTitle' @mouseenter="descTitle='待卖家确认入库'">{{purchaseNum}}</span>
						<i el-icon-arrow-down></i>
						<transition v-if="item.haschildren"  name="dropdown">
							<ul >
								<li v-show="item.isShow && !childrenItem.isShopsooo" :class=" {'active' :isactive === childrenItem.active,'children-item':true}"  v-for="(childrenItem,index02) in item.children" :key="index02" @click.stop="topage(childrenItem,index02,1)">
									{{childrenItem.name}} 
									<span class="cirlce" v-bind:title='descTitle' v-if="childrenItem.active == '/ReturnOrders' && returnNum > 0" @mouseenter="descTitle='待卖家处理退货'">{{returnNum}}</span>
									<span class="cirlce" v-bind:title='descTitle' v-if="childrenItem.active == '/distrustOrder' && returnNum > 0" @mouseenter="descTitle='待仓库确认'">{{returnNum}}</span>
									<span class="cirlce" v-bind:title='descTitle' v-if="childrenItem.active == '/sellerpurchase' && purchaseNum > 0" @mouseenter="descTitle='待卖家确认入库'">{{purchaseNum}}</span>
									<span class="cirlce" v-bind:title='descTitle' v-if="childrenItem.active == '/storePendingOrder' && remindNum > 0" @mouseenter="descTitle='卖家已催单'">{{remindNum}}</span>
								
								</li>
								
							</ul>
						</transition>
					</li>
				</ul>
			</el-aside>
			</el-scrollbar>
		
		
	</div>
</template>

<script>
    import { mapState, mapActions, mapMutations} from 'vuex'
	import orderApi from '../../api/moudles/order'
	import newOrders from '@/api/moudles/newOrders'
	import api from '../../api/api'
	import shopaccessApi from '../../api/moudles/shopaccess'
	import utils from '../../utils/utils.js'
	export default {
		data(){
			return{
				isactive:'',
				userId:JSON.parse(localStorage.getItem('userInfo')).userId,
				userPos:JSON.parse(localStorage.getItem('userInfo')).userPos,
				vipLevel:JSON.parse(localStorage.getItem('userInfo')).vipLevel,
				isShopsooo:JSON.parse(localStorage.getItem('isShopsooo')),
				unreadnum:0,
				descTitle:'待仓库确认',
				returnNum:0,//仓库收到退货的数量
				purchaseNum:0,//待卖家确认的入库单数量
				remindNum:0,//仓库收到卖家催单数量
				isTrue:false,
				btnList:[
					{
						name:this.$t('aside').home,
						icon:'iconfont icon-shouye icon',
						id:0,
						userPos:'SELLER',
						active:'/home',
						vipLevel:0,
						haschildren:false,
						children:[]
					},
					
					{
						name:this.$t('aside.dianpusouquan'),
						icon:'iconfont icon-shouquan icon',
						id:1,
						userPos:'SELLER',
						vipLevel:0,
						active:'/index',
						haschildren:false,
						isShow:false,
					},
					// {
					// 	name:this.$t('aside.claimAssistant'),
					// 	icon:'iconfont icon-suopeitiaojie icon',
					// 	id:2,
					// 	userPos:'SELLER',
					// 	vipLevel:0,
					// 	active:'/claimOrder',
					// 	haschildren:false,
					// 	children:[],
					// },
					// {
					// 	name:this.$t('aside.zhenzifuwu'),
					// 	icon:'iconfont icon-gerenzhongxin icon',
					// 	id:3,
					// 	userPos:'SELLER',
					// 	vipLevel:0,
					// 	active:'/stockProduct/storeTasks',
					// 	haschildren:false,
					// 	children:[],
					// },
					// {
					// 	name:this.$t('aside.Customer_Service'),
					// 	icon:'iconfont icon-kefu1 icon',
					// 	id:4,
					// 	userPos:'SELLER',
					// 	vipLevel:0,
					// 	active:'',
					// 	haschildren:true,
					// 	isShow:false,
					// 	children:[{
					// 		name:this.$t('aside.SmartChat'),
					// 		active:'/chat',
					// 	},{
					// 		name:this.$t('aside.CaringSMS'),
					// 		active:'/remind',
					// 	},{
					// 		name:this.$t('aside.Relevantquotation'),
					// 		active:'/relevant',
							
					// 	},]
					// },
					{
						name:this.$t('aside.wodedingdang'),
						id:5,
						userPos:'SELLER',
						vipLevel:0,
						icon:'iconfont icon-dingdan- icon',
						active:'',
						haschildren:true,
						isShow:true,
						children:[{
							name:this.$t('aside.allOrder'),
							active:'/allOrders',
						},{
							name:this.$t('aside.shenghedang'),
							active:'/reviewOrders',
						},{
							name:this.$t('aside.chulidang'),
							active:'/notHandle',
							
						},{
							name:this.$t('aside.processed'),
							active:'/processedSeller',
							
						},{
							name:this.$t('aside.Returned'),
							active:'/ReturnOrders',
							
						},{
							name:this.$t('homeTwo.OverseasWarehouseComplaintCenter'),
							active:'/complaint',
							
						},]
					},
					{
						name:this.$t('other.a3351'),
						icon:'iconfont icon-cangku1 icon',
						active:'',
						id:6,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:true,
						isShow:false,
						children:[{
							name:this.$t('other.a3352'),
							active:'/gallery/myGallery',
						},
						{
							name:this.$t('other.a3399'),
							active:'/gallery/galleryStandard',
						},
						{
							name:this.$t('other.a3400'),
							active:'/gallery/galleryHeatMap',
						},]
					},
					{
						name:this.$t('aside.xiangshangchanpin'),
						icon:'iconfont icon-cangku1 icon',
						active:'',
						id:6,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:true,
						isShow:false,
						children:[{
							name:this.$t('stockProduct.singlePro'),
							active:'/stockProduct/single',
						},{
							name:this.$t('stockProduct.combo'),
							active:'/stockProduct/combo',
							
						},{
							name:this.$t('stockProduct.gift'),
							active:'/stockProduct/gift',
							
						},]
					},

					{
						name:this.$t('other.a1065'),
						icon:'iconfont icon-cangku1 icon',
						active:'',
						id:6,
						userPos:'SELLER',
						vipLevel:1,//采购员帐号显示
						haschildren:true,
						isShow:true,
						children:[{
							name:this.$t('other.a1066'),
							active:'/stockProduct/single',
						},{
							name:this.$t('other.a1067'),
							active:'/stockProduct/combo',
							
						},{
							name:this.$t('other.a1068'),
							active:'/stockProduct/gift',
							
						},]
					},

					{
						name:this.$t('other.a1069'),
						icon:'iconfont icon-ruku icon',
						id:0,
						userPos:'SELLER',
						active:'/factorysupply/stcokGoods',
						vipLevel:1,//采购员帐号显示
						haschildren:false,
						children:[]
					},

					{
						name:this.$t('other.a1070'),
						icon:'iconfont icon-gerenzhongxin icon',
						id:0,
						userPos:'SELLER',
						active:'/factorysupply/createpurchasing',
						vipLevel:1,//采购员帐号显示
						haschildren:false,
						children:[]
					},

					{
						name:this.$t('aside.rukuguangli'),
						icon:'iconfont icon-ruku icon',
						active:'',
						id:7,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:true,
						isShow:false,
						children:[{
							name:this.$t('aside.purchaseMGM'),
							active:'/factorysupply/createpurchasing',
						},{
							name:this.$t('aside.CreatList'),
							active:'/factorysupply/inbound',
						},{
							name:this.$t('aside.AllLists'),
							active:'/sellerpurchase',
							
						},{
							name:this.$t('aside.rollover'),
							active:'/sellerorder',
							
						}]
					},
					{
						name:this.$t('aside.distribution'),
						icon:'iconfont icon-fenxiaopingtai icon',
						active:'',
						id:8,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:true,
						isShow:false,
						children:[{
							name:this.$t('aside.localGoods'),
							active:'/publicGoods',
						},{
							name:this.$t('aside.mygoods'),
							active:'/myselfproduct/goods',
						},{
							name:this.$t('aside.hasAgent'),
							active:'/hasAgent',
							
						},
						{
							name:this.$t('other.a3244'),
							active:'/SampleApplication',
						}
					]
					},
					{
						name:this.$t('aside.prductDev'),
						icon:'iconfont icon-shangpincaiji icon',
						active:'',
						id:9,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:true,
						isShow:false,
						children:[{
							name:this.$t('aside.collectGoods'),
							active:'/collection',
						},{
							name:this.$t('aside.ProductPending'),
							active:'/factorysupply/productLibrary',
						},{
							name:this.$t('aside.productMGM'),
							active:'/templateManagement',
							
						},]
					},
					{
						name:this.$t('aside.yunweiguanli'),
						icon:'iconfont icon-yunying icon',
						active:'/group',
						id:10,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:false,
						children:[],
					},

					{
						name:this.$t('other.a3242'),
						icon:'iconfont icon-shangpincaiji icon',
						active:'',
						id:78,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:true,
						isShopsooo:false,
						isShow:false,
						children:[{
							name:this.$t('other.a1071'),
							active:'/recharge',
						},
						// {
						// 	name:this.$t('other.a1072'),
						// 	active:'/localStoreRecharge',
						// },{
						// 	name:this.$t('other.a1073'),
						// 	active:'/overseaRecharge',
							
						// },{
						// 	name:this.$t('other.a1074'),
						// 	active:'/erpRecharge',
							
						// },
					]
					},
					{
						name:this.$t('aside.recharge'),
						icon:'iconfont icon-chongzhizhongxin icon',
						active:'/recharge',
						id:11,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:false,
						isShopsooo:this.isShopsooo,
						children:[],
					},

					{
						name:this.$t('aside.invitecashback'),
						icon:'iconfont icon-jiamengyouli icon',
						active:'',
						id:12,
						userPos:'SELLER',
						vipLevel:0,
						haschildren:true,
						isShow:false,
						children:[{
							name:this.$t('aside.myshareLink'),
							active:'/registrationlink',
						},{
							name:this.$t('aside.mysharePage'),
							active:'',
							newWindow:true,
							isShopsooo:JSON.parse(localStorage.getItem('isShopsooo')),

						}]
					},
					{
						name:this.$t('aside').home,
						icon:'iconfont icon-shouye icon',
						id:13,
						userPos:'STORE',
						active:'/storehome',
						vipLevel:0,
						haschildren:false,
						children:[]
					},

					{
						name:this.$t('aside.wodedingdang'),
						id:14,
						userPos:'STORE',
						vipLevel:0,
						icon:'iconfont icon-dingdan- icon',
						active:'',
						haschildren:true,
						isShow:true,
						children:[{
							name:this.$t('aside.chulidang'),
							active:'/storePendingOrder',
						},{
							name:this.$t('aside.fenjianhedui'),
							active:'/precistDelivery',
							
						},{
							name:this.$t('aside.ScanPrint'),
							active:'/scanPrint',
							
						},{
							name:this.$t('aside.daibaochuku'),
							active:'/package',
							
						},{
							name:this.$t('aside.processed'),
							active:'/processedOrder',
							
						},{
							name:this.$t('aside.tuhuanguanli'),
							active:'/distrustOrder',
							
						},{
							name:this.$t('homeTwo.OverseasWarehouseComplaintCenter'),
							active:'/complaintStore',
							
						},]
					},
					{
						name:this.$t('aside.kuchuguanli'),
						icon:'iconfont icon-cangku1 icon',
						active:'/storeManagement/single',
						id:15,
						userPos:'STORE',
						vipLevel:0,
						haschildren:false,
						children:[],
					},
					{
						name:this.$t('aside.godownentry'),
						icon:'iconfont icon-ruku icon',
						active:'/godownentry',
						id:16,
						userPos:'STORE',
						vipLevel:0,
						haschildren:false,
						children:[],
					},
					{
						name:this.$t('aside.transformStore'),
						icon:'iconfont icon-yunying icon',
						active:'/transfer',
						id:17,
						userPos:'STORE',
						vipLevel:0,
						haschildren:false,
						children:[],
					},
					{
						name:this.$t('other.a1075'),
						icon:'iconfont icon-shouye icon',
						id:13,
						userPos:'SELLER',
						active:'/qrCode',
						vipLevel:0,
						haschildren:false,
						children:[]
					},
					{
						name:this.$t('other.a1075'),
						icon:'iconfont icon-shouye icon',
						id:13,
						userPos:'STORE',
						active:'/qrCode',
						vipLevel:0,
						haschildren:false,
						children:[]
					},
					{
						name:this.$t('other.a1076'),
						icon:'iconfont icon-shouye icon',
						id:19,
						userPos:'SELLER',
						active:'/inquiryOrders',
						vipLevel:0,
						haschildren:false,
						children:[]
					},
				]
			}
		},

		computed:{
			...mapState({
				lang:state=>state.login.lang,
				
			}),
			
		
			
		},
		inject:['reload'],
		watch:{
			lang(){
				console.log('lang',this.lang);
				this.reload()
			}
		},

		created(){
			if(this.isShopsooo){
				let num=this.btnList.findIndex(p => p.id == 11)
				this.btnList[num].isShopsooo=!this.isShopsooo
				let num2=this.btnList.findIndex(p => p.id == 78)
				this.btnList[num2].isShopsooo=this.isShopsooo

			}else{
				let num=this.btnList.findIndex(p => p.id == 11)
				this.btnList[num].isShopsooo=true
			}
			this.isactive=window.location.pathname
			this.queryRemindNum()
			this.btnList.forEach(p =>{
				
				if(p.haschildren){
					p.children.forEach(k => {
						if(p.active == this.isactive || k.active == this.isactive){
							p.isShow=false
							this.topage(p,0)
						}
					})
				}
			})
			console.log('url',this.btnList)
		},
		methods:{
		...mapMutations('shopaccess', [
			'SET_STORAGE_TTP',
			'GET_LAZADA_SHOP',
			'DELET_HAS_CLAIM_ALL'
				
		]),

		
		//获取退货，入库待确认的订单数量
		queryRemindNum(){
			newOrders
			.queryRemindNum({userId:this.userId})
			.then(res => {
			if(res.code === 200 ){
			console.log('desc',res.data)
			this.purchaseNum=res.data.purchaseNum
			this.returnNum=res.data.returnNum
			this.remindNum=res.data.remindNum
			
			// this.purchaseNum=res.data.returnNumremindNum
			// this.remindNum=res.data.remindNum

			}else{
			this.$message.warning(res.msg)
			}
			})
		},

        topage(item,index,num){
			this.getUserDetail()
			console.log('item',item)
			if(item.newWindow){
				this.getInviteCode()
			
				return
			}
			if(item.active == '/scanPrint'){
				let shopeePlatform=true
				localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
				let router = this.$router.resolve({ 
					name: 'scanPrint',
				})
				window.open(router.href, '_blank');
				return
			}
			if(item.active == '/package'){
				let shopeePlatform=true
				localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
				let router = this.$router.resolve({ 
					name: 'package',
				})
				window.open(router.href, '_blank');
				return
			}
			if( item.active == '/precistDelivery'){
				let shopeePlatform=true
				localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
				let router = this.$router.resolve({ 
					name: 'precistDelivery',
				})
				window.open(router.href, '_blank');
				return
			}

            if(num ==0 && !item.isShow){
                this.btnList.forEach(p => {
						p.isShow=false
                })
            }
            item.isShow=!item.isShow
            this.$router.push(item.active)
			setTimeout(() => {
				this.isactive=window.location.pathname
			},100)
        },


		//获取用户邀请码
		getInviteCode(){
			newOrders
			.getUserInviteCode({userId:this.userId})
			.then(res => {
			if(res.code === 200 ){
			console.log('desc',res.data)
			
			window.open('https://i.shopsbu.com/?invitationCode=' + res.data.invitationCode )
		
			}else{
			this.$message.warning(res.msg)
			}
			})
		},

		getUserDetail(){
			shopaccessApi
			.getUserInfo({userId:JSON.parse(localStorage.getItem('userInfo')).userId})
			.then(res => {
				if(res.code === 200){
					
					this.DELET_HAS_CLAIM_ALL(res.data)
					let data=res.data
					
					if(data.shopeeShops || data.lazadaShops || data.tiktokShops){
						localStorage.setItem('shophasAuthorization', true)
					}else{
						localStorage.setItem('shophasAuthorization', false)
					}
					if(data.userPos=== 'STORE'){
						localStorage.setItem('shophasAuthorization', true)
					}
					this.GET_LAZADA_SHOP(data.lazadaShops)
					localStorage.setItem('userInfo', JSON.stringify(data))
					localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
					localStorage.setItem('warehouse', JSON.stringify(data.stores))
					localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
					localStorage.setItem('temuAuth', JSON.stringify(data.temuAuth))
				} 
			})
		},
			
		}
	}
</script>

<style lang="scss" scoped>

.asideTab{
	position: fixed;
    top: 50px;
    display: flex;
    height: 100vh;
    flex-direction: column;
    background-color: #fff;

	.personal{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(50,50,50,.1)
	}
	.personal-header{
		height: 50px!important;
		background-color: #45c8db;
		line-height: 50px;
		font-size: 20px;
		color:#fff!important;
		display: flex;
		justify-content: space-between;
		
	}
	.personal-aside{
		box-sizing: border-box;
		background-color: #fff;
		padding-bottom: 100px;
		width: 205px!important;
		min-height: 100vh;
		border-right: 1px solid #eee;
	}
	.personal-main{
		width: 100%;
		background-color: #f4f7fd;
		overflow-y: scroll;
		height: 100vh;
	}
	.btn-item{
		line-height: 44px;
		cursor: pointer;
		padding-left: 15px;
		box-sizing: border-box;
		font-weight: 510!important;
	}
	

	.icon{
		padding: 0 10px;
		font-size: 20px;
	}
	
	.cirlce{
	
		display: inline-block;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		line-height: 20px;

		text-align: center;
		font-size: 6px;
		color: #fff;
		background-color: red;
	}
	
	.children-item{
		font-size: 14px;
		padding-left: 40px;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
	}
	

	.active{
		background-color: #f6f5fc;
		color: rgb(64, 169, 255);
		position: relative;
	}

	.active::after{
		content: '';
		position: absolute;
		width: 3px;
		height: 45px;
		background-color: rgb(64, 169, 255);
		left: 0px;
	}
	
	
	.dropdown-leave-active,.dropdown-enter-active {
	    transition: max-height 1s linear;
	}
	.dropdown-enter,.dropdown-leave-to {
	    max-height:0 ;
	    
	}
	.dropdown-enter-to,.dropdown-leave {
	    max-height: 136px ;
	}
	
	.el-icon-arrow-up{
		padding-left: 15px;
	}
	
	.el-icon-arrow-down{
		padding-left: 15px;
	}



	.el-main{
		box-sizing: border-box;
		padding: 0;
	}
}
	
	
	

	
</style>
